module.exports = __webpack_public_path__ + "static/media/process.e97fc26b.svg";